import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import armchair from '../assets/armchair-green-living-room-with-copy-space-min.jpg';
import gallery from '../assets/spacejoy-c0JoR_-2x3E-unsplash.jpg';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Config/Config';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const About = () => {
  const [homeData, setHomeData] = React.useState(null);
  // helper: escape user-provided keywords for regex
  const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Render text with highlighted keywords. Returns array of React nodes.
  const renderHighlighted = (text = '', keywords = []) => {
    if (!text) return text;
    const safeKeywords = keywords.filter(Boolean).map(escapeRegExp);
    if (safeKeywords.length === 0) return text;
    const pattern = new RegExp(`(${safeKeywords.join('|')})`, 'gi');
    const parts = text.split(pattern);
    return parts.map((part, i) => {
      if (safeKeywords.some(k => new RegExp(`^${k}$`, 'i').test(part))) {
        return (
          <span key={i} className="text-brand-primary font-semibold">{part}</span>
        );
      }
      return <span key={i}>{part}</span>;
    });
  };

  // Split long text into paragraphs. Tries double-newline, then single newline, then sentences.
  const renderParagraphs = (text = '', keywords = []) => {
    if (!text) return null;
    const byDouble = text.split(/\n{2,}/).map(t => t.trim()).filter(Boolean);
    const blocks = byDouble.length > 1 ? byDouble : text.split(/\n+/).map(t => t.trim()).filter(Boolean);
    // if still single block and contains multiple sentences, split into sentence paragraphs
    const finalBlocks = blocks.length === 1 ? blocks[0].split(/(?<=\.)\s+/).map(t => t.trim()).filter(Boolean) : blocks;
    return finalBlocks.map((blk, idx) => (
      <p key={idx} className="text-lg text-slate-600 leading-relaxed">{renderHighlighted(blk, keywords)}</p>
    ));
  };

  // Render title in two colors: split by '|' if provided, else split words in half.
  const renderTwoColorTitle = (title = '') => {
    if (!title) return null;
    // if author provided explicit split using '|' or '-' use that
    let first = title;
    let second = '';
    if (title.includes('|')) {
      const parts = title.split('|').map(p => p.trim());
      first = parts[0];
      second = parts.slice(1).join(' | ');
    } else if (title.includes('-')) {
      const parts = title.split('-').map(p => p.trim());
      first = parts[0];
      second = parts.slice(1).join(' - ');
    } else {
      const words = title.split(/\s+/).filter(Boolean);
      if (words.length > 1) {
        const mid = Math.ceil(words.length / 2);
        first = words.slice(0, mid).join(' ');
        second = words.slice(mid).join(' ');
      }
    }

    return (
      <>
        <span>{first}</span>
        {second ? <span className="text-brand-primary"> {second}</span> : null}
      </>
    );
  };
  useEffect(() => {
    const getData = async () => {
      const ref = doc(db, "website-management", "about");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setHomeData(snap.data());
      } else {
        console.log("home-page document not found");
      }
    };

    getData();
   
   
  }, []);
  return (
    <div className="bg-gray-50 min-h-screen font-sans text-slate-800 mt-[100px]">
      {/* Hero Section */}
      {/* <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden w-full">
        <div className="absolute inset-0">
          <img 
            src={armchair} 
            alt="Interior Design Hero" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px]"></div>
        </div>
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-6xl font-bold text-white mb-4 font-heading"
          >
            Crafting Spaces, <span className="text-brand-primary">Inspiring Lives</span>
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto"
          >
            Your partner in total interior solutions. Precision, aesthetics, and excellence in every detail.
          </motion.p>
        </div>
      </section> */}

      {/* Who We Are Section */}
      <section className="py-16 md:py-24 px-4">
        
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <motion.div 
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.span variants={fadeInUp} className="text-brand-primary font-semibold tracking-wider uppercase text-sm">Who We Are</motion.span>
            <motion.h2 variants={fadeInUp} className="text-3xl md:text-4xl font-bold mt-2 mb-6 text-slate-900">
              {renderTwoColorTitle(homeData?.title || 'Shape Interior Solutions')}
            </motion.h2>
            <motion.div variants={fadeInUp} className="mb-6">
              {renderParagraphs(homeData?.description || '', [
                'Shape Interior Solutions',
                'Projects',
                'B2B',
                'pioneers',
                'Kerala',
              ])}
            </motion.div>
           
            <motion.div variants={fadeInUp}>
              <Link to="/contact" className="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-white bg-brand-primary hover:bg-brand-dark rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                Get in Touch
              </Link>
            </motion.div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-brand-primary/10 rounded-2xl transform rotate-3"></div>
            <img 
              src={homeData?.image || gallery} 
              alt="Interior Workshop" 
              className="relative rounded-xl shadow-2xl w-full h-[400px] md:h-[500px] object-cover"
            />
          </motion.div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Mission Card */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="bg-slate-50 p-8 md:p-10 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-brand-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-slate-900">Our Mission</h3>
              <div className="text-slate-600 text-lg leading-relaxed">
               {renderParagraphs(homeData?.mission || '', [
                 'transform',
                 'safety',
                 'aesthetic',
                 'budget',
                 'timeline',
               ])}
              </div>
            </motion.div>

            {/* Vision Card */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-slate-50 p-8 md:p-10 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-brand-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-slate-900">Our Vision</h3>
              <div className="text-slate-600 text-lg leading-relaxed">
               {renderParagraphs(homeData?.vision || '', [
                 'Inspiration',
                 'Innovation',
                 'Sustainability',
                 'clients',
               ])}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Why Choose Us / Stats (Optional but adds value) */}
      {/* <section className="py-16 bg-brand-dark text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold mb-12"
          >
            Why Choose Shape Interior?
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { title: "Precision", desc: "State-of-the-art CNC cutting and processing." },
              { title: "Timelines", desc: "Committed to delivering projects on schedule." },
              { title: "Support", desc: "Dedicated on-site support and consultation." }
            ].map((item, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="p-6 border border-white/10 rounded-xl bg-white/5 backdrop-blur-sm"
              >
                <h4 className="text-xl font-bold mb-2 text-brand-primary">{item.title}</h4>
                <p className="text-gray-300">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      {/* <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.h2 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold mb-6 text-slate-900"
          >
            Ready to Transform Your Space?
          </motion.h2>
          <p className="text-lg text-slate-600 mb-8">
            Explore our services or contact us directly to discuss your next project.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/services" className="px-8 py-3 rounded-lg bg-white border border-slate-300 text-slate-700 font-medium hover:bg-slate-50 hover:border-slate-400 transition-all">
              View Services
            </Link>
            <Link to="/contact" className="px-8 py-3 rounded-lg bg-brand-primary text-white font-medium hover:bg-brand-dark shadow-lg hover:shadow-xl transition-all">
              Contact Us
            </Link>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
